export default {
  getAuthEmployee: "employee/getAuthenticatedEmployee",
  leaveEmployee: (id) => "hrmis/leave_employee?number=" + id,
};
